const passwordResetMessages = {
  // Forgot Password Page
  FORGOT_PASSWORD_HEADING: 'Reset your password',
  FORGOT_PASSWORD_SUBHEADING: 'Forgot your password?',
  FORGOT_PASSWORD_SUGGESTION_TEXT: 'Are you sure you want to reset the password for this email address?',
  FORGOT_PASSWORD_EMAIL_LABEL: 'Email Address',
  FORGOT_PASSWORD_USERNAME_LABEL: 'Username (Optional)',
  FORGOT_PASSWORD_BUTTON_TEXT: 'Send Reset Link',
  FORGOT_PASSWORD_BACK_TO_LOGIN: 'Back to Login',

  // Reset Password Page
  RESET_PASSWORD_HEADING: 'Create new password',
  RESET_PASSWORD_SUBHEADING: 'Set your new password',
  RESET_PASSWORD_SUGGESTION_TEXT: 'Your new password must be different from your previous password.',
  RESET_PASSWORD_NEW_PASSWORD_LABEL: 'New Password',
  RESET_PASSWORD_CONFIRM_PASSWORD_LABEL: 'Confirm Password',
  RESET_PASSWORD_BUTTON_TEXT: 'Reset Password',
  RESET_PASSWORD_BACK_TO_LOGIN: 'Back to Login',

  // Success Messages
  FORGOT_PASSWORD_SUCCESS: 'If the email address is registered, you will receive a password reset link shortly.',
  RESET_PASSWORD_SUCCESS: 'Your password has been reset successfully. You can now log in with your new password.',

  // Error Messages
  FORGOT_PASSWORD_EMAIL_REQUIRED: 'Email address is required',
  FORGOT_PASSWORD_INVALID_EMAIL: 'Please enter a valid email address',
  RESET_PASSWORD_TOKEN_REQUIRED: 'Reset token is required',
  RESET_PASSWORD_PASSWORD_REQUIRED: 'New password is required',
  RESET_PASSWORD_CONFIRM_PASSWORD_REQUIRED: 'Please confirm your password',
  RESET_PASSWORD_PASSWORDS_DONT_MATCH: 'Passwords do not match',
  RESET_PASSWORD_PASSWORD_TOO_SHORT: 'Password must be at least 8 characters long',
  RESET_PASSWORD_PASSWORD_TOO_LONG: 'Password must be no more than 128 characters long',
  INVALID_OR_EXPIRED_TOKEN: 'Invalid or expired reset token',
  TOKEN_ALREADY_USED: 'This reset link has already been used',

  // Login Page Integration
  LOGIN_FORGOT_PASSWORD_LINK: 'Forgot Password?',
  // Validation Messages
  PASSWORD_VALIDATION_LENGTH: 'Password must be 8-128 characters long',
  PASSWORD_VALIDATION_UPPERCASE: 'Password must contain at least one uppercase letter',
  PASSWORD_VALIDATION_DIGIT: 'Password must contain at least one number',

  // Loading States
  SENDING_RESET_LINK: 'Sending reset link...',
  RESETTING_PASSWORD: 'Resetting password...',
  VALIDATING_TOKEN: 'Validating reset link...',

  // Email Instructions
  EMAIL_INSTRUCTIONS_TITLE: 'Check your email',
  EMAIL_INSTRUCTIONS_MESSAGE: 'We\'ve sent password reset instructions to your email address.',
  EMAIL_INSTRUCTIONS_RESEND: 'Didn\'t receive the email? Check your spam folder or',
  EMAIL_INSTRUCTIONS_RESEND_LINK: 'try again',

  // Token Validation
  TOKEN_VALID: 'Reset token is valid',
  TOKEN_EXPIRED: 'Reset token has expired',
  TOKEN_INVALID: 'Reset token is invalid',

  // Rate Limiting
  RATE_LIMIT_EXCEEDED: 'Too many password reset requests. Please wait before trying again.',
  RATE_LIMIT_WARNING: 'You can request a password reset once every 15 minutes.',
  RATE_LIMIT_COUNTDOWN: 'You can try again in {minutes} minutes and {seconds} seconds.',
  RATE_LIMIT_COOLDOWN_EXPIRED: 'You can now request a new password reset.',

  // Security Features
  SUSPICIOUS_ACTIVITY_DETECTED: 'Suspicious activity detected. Please try again later.',
  ACCOUNT_TEMPORARILY_LOCKED: 'Account temporarily locked due to multiple failed attempts.',
  SECURITY_NOTICE: 'For your security, we limit password reset requests.',

  // Session Security
  SESSION_EXPIRED_DURING_RESET: 'Your session has expired. Please start the password reset process again.',
  MULTIPLE_RESET_ATTEMPTS: 'Multiple password reset attempts detected. Please check your email for existing reset links.',

  // Browser Security
  BROWSER_NOT_SUPPORTED: 'Your browser may not support all security features. Please use a modern browser.',
  JAVASCRIPT_REQUIRED: 'JavaScript is required for secure password reset functionality.',

  // General
  PLEASE_WAIT: 'Please wait...',
  TRY_AGAIN: 'Please try again',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
};

export default passwordResetMessages;